import React, { useEffect, useRef, useState } from "react";
import { Building2 } from "lucide-react";
import { api } from "@/lib/api";

export default function OrgNameInput({ value, onChange, es = false }: { value: string; onChange: (v: string) => void; es?: boolean }) {
  const [items, setItems] = useState<string[]>([]);
  const [open, setOpen] = useState(false);
  const [hi, setHi] = useState(-1);
  const picked = useRef(false);

  useEffect(() => {
    if (picked.current) { picked.current = false; return; }
    if (value.trim().length < 2) { setItems([]); return; }
    const t = setTimeout(() => {
      api.get("/public/org-suggest", { params: { q: value } }).then((r) => {
        const list: string[] = r.data.filter((n: string) => n.toLowerCase() !== value.trim().toLowerCase());
        setItems(list); setOpen(list.length > 0); setHi(-1);
      }).catch(() => setItems([]));
    }, 200);
    return () => clearTimeout(t);
  }, [value]);

  const pick = (n: string) => { picked.current = true; onChange(n); setOpen(false); setItems([]); };
  const onKey = (e: React.KeyboardEvent) => {
    if (!open || !items.length) return;
    if (e.key === "ArrowDown") { e.preventDefault(); setHi((h) => Math.min(items.length - 1, h + 1)); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setHi((h) => Math.max(-1, h - 1)); }
    else if (e.key === "Enter" && hi >= 0) { e.preventDefault(); pick(items[hi]); }
    else if (e.key === "Escape") setOpen(false);
  };

  return (
    <div className="relative">
      <input id="org_name" data-testid="org-order-name-input" required minLength={2} autoComplete="off" className="field-input" value={value}
        onChange={(e) => onChange(e.target.value)} onKeyDown={onKey} onFocus={() => items.length && setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)}
        placeholder={es ? "Iglesia Comunidad de Gracia" : "Grace Community Church"} />
      {open && items.length > 0 && (
        <div className="absolute z-20 mt-1.5 w-full overflow-hidden rounded-xl border border-[#F26B4F]/25 bg-white shadow-lg" data-testid="org-suggest-list">
          <p className="bg-[#FFF6EE] px-4 py-2 text-xs font-semibold text-[#C2410C]">{es ? "¿Es una de estas? O siga escribiendo." : "Is it one of these? Or just keep typing."}</p>
          {items.map((n, i) => (
            <button key={n} type="button" onMouseDown={(e) => { e.preventDefault(); pick(n); }} data-testid={`org-suggest-item-${i}`}
              className={`flex w-full items-center gap-2 px-4 py-2.5 text-left text-[15px] transition-colors ${i === hi ? "bg-[#FFE4D6]" : "hover:bg-[#FFF6EE]"}`}>
              <Building2 className="h-4 w-4 shrink-0 text-[#F26B4F]" /> {n}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
